/**
 * iOS WKWebView（尤其外层再套一层 WebView）里，勾选行在可滚容器中：
 * 手指静止点击也会有十几像素抖动，UIScrollView 默认会把这次触摸判成滚动，click / touchend 被取消。
 * 只对勾选图标（约 44pt）在容差内 preventDefault（必须 non-passive），不让父级滚动抢走点图标；整行文字仍可滑动。超出容差才当滚动。
 */
export const IOS_TAP_SLOP_PX = 24;

const TAP_ROOT = '[data-tap-activate]';

let installed = false;

const installIosTapSlop = () => {
  if (installed || typeof document === 'undefined') return;
  installed = true;

  let tracking: { x: number; y: number; moved: boolean } | null = null;

  document.addEventListener(
    'touchstart',
    (e) => {
      const root = (e.target as Element | null)?.closest?.(TAP_ROOT);
      const t = e.changedTouches?.[0] ?? e.touches?.[0];
      if (!root || !t) {
        tracking = null;
        return;
      }
      tracking = { x: t.clientX, y: t.clientY, moved: false };
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    'touchmove',
    (e) => {
      if (!tracking || tracking.moved) return;
      const t = e.touches?.[0];
      if (!t) return;
      const dx = Math.abs(t.clientX - tracking.x);
      const dy = Math.abs(t.clientY - tracking.y);
      if (dx <= IOS_TAP_SLOP_PX && dy <= IOS_TAP_SLOP_PX) {
        if (e.cancelable) e.preventDefault();
        return;
      }
      tracking.moved = true;
    },
    { capture: true, passive: false },
  );

  const clear = () => {
    tracking = null;
  };
  document.addEventListener('touchend', clear, { capture: true, passive: true });
  document.addEventListener('touchcancel', clear, { capture: true, passive: true });
};

installIosTapSlop();
